module.exports = __webpack_public_path__ + "img/bn.80c35c4.svg";